<template>
  <div class="">
    <div class="mgb80">
      <div class="content-web">
        <div class="inner_content_right">
          <div class="wp_single wp_column_article">
            <div class="wp_entry">
              <div class="wp_articlecontent">
                <div class="head">
                  <div class="lsd">天津新远进出口有限公司</div>
                  <p class="p1">
                    天津新远进出口有限公司是天津市旅游（控股）集团有限公司下属的全资子公司，于2015年底在天津东疆港自贸区内注册成立，注册资本1亿人民币，主要经营大宗石油化工品，主要产品有原料油、燃料油、沥青、成品油等，具备危险化学品和成品油经营资质。
                  </p>
                  <div class="p1">
                    从成立初，新远公司致力于积极拓展业务市场，逐步形成了以原料油、燃料油、混合芳烃、铁合金、矿产等产品为主的业务结构，经过六年多的运行，业已形成成熟的上下游购销渠道，进入中海油供应体系，通过与行业内主流公司的强强联合，从源头入手，致力于为客户提供品质可靠，供货稳定，交货及时的产品和服务。
                  </div>

                  <div class="img1">
                    <img
                      src="@/assets/images/xyjck.png"
                      alt=""
                      height="450px"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.mgb80 {
  margin-bottom: 80px;
  margin-top: 30px;
  .content-web {
    display: flex;
    width: 100%;
    // min-width: 1200px;
    margin: 0 auto;
    .inner_content_right {
      // float: right;
      //   box-sizing: border-box;
      //   width: 960px;
      //   min-height: 600px;
      //   margin-left: 20px;
      //   background-color: #fff;
      .wp_single.wp_column_article {
        padding: 48px 40px 100px 40px;
      }
      .wp_entry {
        line-height: 2em !important;
        font-size: 14px !important;
        font-family: "宋体" !important;
        width: 100%;
        line-height: 1.7em;
        font-size: 13px;
        color: #333;
        overflow: hidden;;
        .head {
          border-bottom: 1px #444 dashed;
          height: 100%;
          .lsd {
            font-size: 20px;
            text-align: center;
            font-weight: 800;
            margin-bottom: 20px;
          }
          .p1 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .p2 {
            text-indent: 35px;
            margin-bottom: 20px;
          }
          .img1 {
            text-align: center;
            margin-bottom: 20px;
          }
        }
      }
      .text {
        text-indent: 35px;
      }
      .ltd {
        float: right;
      }
    }
  }
}
</style>